import { BaseService } from '../../infra/base.service'
import type { Integration } from './integration'
import type { IntegrationsRepository } from './integrations.repository'

export class IntegrationsService extends BaseService<Integration> {
    constructor(private rep: IntegrationsRepository) {
        super(rep)
    }
}
